import { useCallback } from 'react';

import { Filter, ItemWithID, useCoPilotSectionState } from '../../contexts/CoPilotSectionContext';
import { TabNavigation } from '../TabNavigation';

export const FilterTabs: React.FC<{ totalCount?: number; primaryCount?: number; secondaryCount?: number }> = ({
  primaryCount,
  secondaryCount,
}) => {
  const allTab = 'All clients';
  const primaryTab = primaryCount !== undefined ? `Primary clients (${primaryCount})` : `Primary clients`;
  const secondaryTab = secondaryCount !== undefined ? `Secondary clients (${secondaryCount})` : `Secondary clients`;
  const tabs = [allTab, primaryTab, secondaryTab];

  const { handleFilterChange } = useCoPilotSectionState<ItemWithID>();

  const onFilterTabChange = useCallback(
    (selected: string) => {
      const shortTabName = selected.split(' (')[0];
      const filtersByFilterTabName: { [key: string]: Filter[] } = {
        'All clients': ['primary', 'secondary'],
        'Primary clients': ['primary'],
        'Secondary clients': ['secondary'],
      };
      const filters: Filter[] = selected ? filtersByFilterTabName[shortTabName] : [];
      handleFilterChange(filters);
    },
    [handleFilterChange]
  );

  return <TabNavigation tabs={tabs} onChange={onFilterTabChange} panelStyle={{ padding: 0 }} />;
};

export default FilterTabs;
